import { render, staticRenderFns } from "./DynamicsEdit.vue?vue&type=template&id=59e8cd5e&scoped=true&"
import script from "./DynamicsEdit.vue?vue&type=script&lang=js&"
export * from "./DynamicsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e8cd5e",
  null
  
)

export default component.exports